import { render, staticRenderFns } from "./ElementPrice.vue?vue&type=template&id=15b87da3&"
import script from "./ElementPrice.vue?vue&type=script&lang=js&"
export * from "./ElementPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports